import { useEffect, useRef, useState } from 'react';

export type LegalDoc = 'terms' | 'privacy' | 'accessibility' | 'cancel' | 'shipping';

type Props={
  open:LegalDoc|null;
  onClose:()=>void;
  onNavigate:(doc:LegalDoc)=>void;
  email:string;
  phone:string;
};

const UPDATED='26.08.2026';
const BUSINESS_NAME='מיכה לסרי';
const BUSINESS_ID='031755705';
const BUSINESS_ADDRESS='רפאלי שרגא 9, פתח תקווה';

const Section=({id,title,children}:{id?:string;title:string;children:React.ReactNode})=>
  <section id={id} className="mlc-section"><h3>{title}</h3>{children}</section>;

const BusinessBox=({email,phone}:{email:string;phone:string})=>
 <div className="mlc-business-box">
  <b>פרטי מפעיל האתר</b>
  <p>MIELLEY — מופעל על ידי {BUSINESS_NAME}, מס׳ עוסק/זיהוי {BUSINESS_ID}.</p>
  <p>כתובת: {BUSINESS_ADDRESS}.</p>
  <p>דוא״ל: <a href={`mailto:${email}`}>{email}</a> · טלפון: <a href={`tel:${phone}`}>{phone}</a>.</p>
  <small>הכתובת אינה בהכרח נקודת קבלת קהל או החזרת מוצרים ללא תיאום מראש.</small>
 </div>;


function Shipping({email,phone,onNavigate}:{email:string;phone:string;onNavigate:(d:LegalDoc)=>void}){
 return <>
  <div className="mlc-doc-intro">
   <span>MIELLEY · DELIVERY & RETURNS</span>
   <h2>משלוחים, החזרות והחלפות</h2>
   <p>כל מה שחשוב לדעת מרגע ההזמנה ועד קבלת התכשיט, החזרה, החלפה או טיפול במקרה של פגם — בשקיפות ובכפוף לזכויות הצרכן לפי הדין.</p>
  </div>

  <BusinessBox email={email} phone={phone}/>

  <div className="mlc-shipping-highlights" aria-label="עיקרי מדיניות משלוחים והחזרות">
   <article><span>01</span><b>הזמנה ואישור</b><p>לאחר ביצוע ההזמנה מתקבל אישור בהתאם לתהליך באתר. זמינות סופית כפופה לאימות מלאי ותשלום.</p></article>
   <article><span>02</span><b>אריזה ומשלוח</b><p>התכשיטים נארזים בקפידה. אופן המשלוח, העלות וזמן האספקה הרלוונטיים מוצגים באתר או בתהליך ההזמנה.</p></article>
   <article><span>03</span><b>החזרה או החלפה</b><p>פונים אלינו מראש עם מספר הזמנה. אנו שולחים הנחיות מסודרות ומטפלים בבקשה בהתאם לסוג המוצר ולדין.</p></article>
  </div>

  <Section title="1. אזורי משלוח ואפשרויות אספקה">
   <p>MIELLEY מספקת הזמנות לכתובות ולאזורי מסירה בהתאם לאפשרויות הזמינות בעת ביצוע ההזמנה. אפשרויות המשלוח, עלותן והערכת זמן האספקה יוצגו ללקוח באתר, בקופה או באישור ההזמנה, לפי העניין.</p>
   <p>אם מוצגת באתר הטבת משלוח חינם מעל סכום קנייה מסוים, ההטבה תחול בהתאם לתנאים המוצגים בזמן ההזמנה, לאחר קיזוז קופונים/החזרות ככל שנדרש. מבצעים ותנאי משלוח עשויים להשתנות מעת לעת, אך שינוי לא יפגע בהזמנה שכבר אושרה בניגוד לדין.</p>
  </Section>

  <Section title="2. זמני הכנה ואספקה">
   <p>מועד האספקה המחייב הוא המועד שנמסר ללקוח במסגרת העסקה, בכפוף לדין. זמן האספקה עשוי לכלול זמן הכנה של התכשיט וזמן הובלה על ידי חברת השילוח.</p>
   <p>מוצר במלאי עשוי להישלח מהר יותר ממוצר הדורש מידה, התאמה, חריטה, שינוי או הכנה מיוחדת. כאשר מדובר בהזמנה אישית, נמסור ככל האפשר מידע על לוח הזמנים לפני או לאחר אישור ההזמנה.</p>
   <p>שבתות, חגים, ערבי חג, מצב ביטחוני, מזג אוויר קיצוני, עומסים חריגים או אירועים שאינם בשליטת MIELLEY עשויים להשפיע על זמני השילוח. במקרה של עיכוב מהותי נפעל לעדכון הלקוח ולמתן מענה בהתאם לזכויותיו לפי דין.</p>
  </Section>

  <Section title="3. כתובת, פרטי קשר וניסיון מסירה">
   <p>באחריות הלקוח למסור שם, טלפון, כתובת ופרטי מסירה נכונים ומלאים. טעות בפרטים עלולה לגרום לעיכוב או למשלוח חוזר. אם נגרמה עלות נוספת עקב פרטים שגויים שמסר הלקוח, ניתן יהיה לחייב בעלות סבירה רק ככל שהדין מאפשר ולאחר עדכון הלקוח.</p>
   <p>במקרה של ניסיון מסירה שלא צלח, יש לפעול בהתאם להודעת חברת השילוח או ליצור איתנו קשר כדי שנוכל לסייע.</p>
  </Section>

  <Section title="4. קבלת החבילה ובדיקת המוצר">
   <p>עם קבלת המשלוח מומלץ לבדוק שהחבילה והתכשיט הגיעו תקינים ותואמים להזמנה. אם קיימת פגיעה נראית לעין באריזה, מוצר שגוי, חוסר או נזק, מומלץ לצלם את האריזה והמוצר ולפנות אלינו בהקדם.</p>
   <p>המלצה לפנות בהקדם נועדה לאפשר טיפול מהיר ואינה גורעת מזכות צרכנית או אחריות שלא ניתן להתנות עליה לפי דין.</p>
  </Section>

  <Section title="5. ביטול עסקת מכר מרחוק והחזרת מוצר">
   <p>רכישה באתר היא בדרך כלל עסקת מכר מרחוק. בהתאם לחוק הגנת הצרכן, קיימת לצרכן, בכפוף לתנאי החוק ולחריגיו, זכות לבטל עסקה לרכישת מוצר בתוך התקופה הקבועה בדין — בדרך כלל עד 14 ימים מהמועד הקובע לפי החוק.</p>
   <p>במקרים שבהם הדין מעניק תקופת ביטול מורחבת, לרבות לאוכלוסיות מסוימות ובהתקיים התנאים שנקבעו בחוק, נפעל בהתאם לזכות המורחבת.</p>
   <p>עצם פתיחת האריזה או בדיקה סבירה של המוצר אינן שוללות בהכרח את זכות הביטול בעסקת מכר מרחוק. עם זאת, אם נגרם למוצר נזק או ירידת ערך עקב שימוש שאינו נדרש לבדיקה סבירה, עשויות לחול הוראות הדין הרלוונטיות.</p>
  </Section>

  <Section title="6. דמי ביטול ועלות החזרת המוצר">
   <p>כאשר ביטול העסקה אינו עקב פגם, אי־התאמה, אי־אספקה במועד או הפרה אחרת המזכה את הצרכן לפי דין, ניתן לגבות דמי ביטול רק בשיעור המותר בחוק — בדרך כלל עד 5% ממחיר העסקה או 100 ₪, לפי הנמוך.</p>
   <p>בביטול רגיל שאינו עקב פגם או אי־התאמה, האחריות והעלות להחזרת המוצר לעסק עשויות לחול על הלקוח בהתאם לדין. במקרה של ביטול עקב פגם, אי־התאמה או אי־אספקה במועד, לא ייגבו דמי ביטול ככל שהחוק אוסר זאת, והטיפול בהחזרת המוצר ייעשה בהתאם לחובות החלות על העסק.</p>
  </Section>

  <Section title="7. מוצר פגום, מוצר שגוי או אי־התאמה">
   <p>אם התקבל מוצר פגום, שגוי או שאינו תואם את פרטי העסקה, פנו אלינו ל־${email} או בטלפון ${phone}, בצירוף מספר ההזמנה ותיאור הבעיה. תמונות יכולות לסייע בזירוז הטיפול.</p>
   <p>נבדוק את המקרה ונציע פתרון מתאים — תיקון, החלפה, אספקת מוצר תואם, ביטול והשבה או פתרון אחר — בהתאם לנסיבות, לאחריות ולזכויות הקבועות בדין.</p>
  </Section>

  <Section title="8. החלפת מידה או דגם">
   <p>בקשה להחלפת מידה או דגם שאינה נובעת מפגם תטופל בהתאם לזמינות מלאי, מצב המוצר והוראות הדין. ייתכן הפרש מחיר בין דגמים או מידות, ואם קיים הפרש הוא יוצג ויאושר לפני ביצוע ההחלפה.</p>
   <p>לפני שליחת מוצר להחלפה יש ליצור קשר עם MIELLEY ולקבל הנחיות. אין לשלוח תכשיט לכתובת העסק ללא תיאום, כדי למנוע אובדן או עיכוב בזיהוי החבילה.</p>
  </Section>

  <Section title="9. מוצרים שיוצרו או הותאמו במיוחד">
   <p>מוצר שיוצר, נחרט, שונה או הותאם במיוחד לפי מידות או דרישות ייחודיות של הלקוח עשוי להיות כפוף להסדרי ביטול שונים. החרגה מזכות הביטול תחול רק ככל שמתקיימים התנאים שנקבעו בדין.</p>
   <p>אם טרם החל הייצור או ההתאמה, או אם הדין מאפשר ביטול בשלב הרלוונטי, נפעל בהתאם להוראות החוק. אנו ממליצים לפנות אלינו מיד עם קבלת החלטה על ביטול מוצר מותאם.</p>
  </Section>

  <Section title="10. מצב המוצר בעת החזרה">
   <p>יש להחזיר את התכשיט כשהוא מוגן היטב ובצירוף הפריטים שנמסרו עמו ככל שניתן. אין באריזה המקורית כשלעצמה תנאי השולל זכות ביטול שלא ניתן להתנות עליה, אך אריזה נכונה מסייעת למנוע נזק בזמן ההחזרה.</p>
   <p>מומלץ שלא לשלוח תכשיט במעטפה רגילה. יש להשתמש באריזה קשיחה ובשיטת משלוח הניתנת למעקב כאשר האחריות להחזרה מוטלת על הלקוח.</p>
  </Section>

  <Section title="11. החזר כספי">
   <p>כאשר קיימת זכאות להשבה, MIELLEY תשיב את הסכום במועד ובאופן הקבועים בדין. בעסקת מכר מרחוק, הדין קובע במקרים הרלוונטיים השבה בתוך 14 ימים ממועד קבלת הודעת הביטול וביטול החיוב בהתאם לחוק.</p>
   <p>לאחר ביצוע הזיכוי מצד העסק, זמן הופעתו בפועל בכרטיס או בחשבון עשוי להיות תלוי בחברת האשראי, הבנק או ספק התשלום.</p>
  </Section>

  <Section title="12. החזרה בדואר או באמצעות חברת שילוח">
   <p>לפני החזרה יש לפנות אלינו ולקבל כתובת והנחיות עדכניות. הכתובת הרשומה של העסק היא רפאלי שרגא 9, פתח תקווה, אך אין לשלוח אליה תכשיט ללא תיאום ואישור מאיתנו.</p>
   <p>כאשר הלקוח אחראי למשלוח ההחזרה, מומלץ לשמור את מספר המעקב ואת אישור המשלוח עד לסיום הטיפול.</p>
  </Section>

  <Section title="13. אובדן או נזק במהלך משלוח">
   <p>אם משלוח אל הלקוח אבד או ניזוק לפני מסירתו, יש לפנות אלינו ונבדוק את האירוע מול חברת השילוח. זכויות הצדדים ייקבעו בהתאם לדין ולנסיבות המסירה.</p>
   <p>כאשר הלקוח שולח מוצר חזרה באחריותו, מומלץ להשתמש בשירות עם מעקב ואריזה מתאימה. אין באמור כדי לגרוע מחובה החלה על MIELLEY במקרה שבו הדין מטיל עליה את האחריות לאיסוף או להחזרה.</p>
  </Section>

  <Section title="14. אחריות ותיקון לאחר תקופת ההחזרה">
   <p>בקשה הנוגעת לפגם ייצור או אחריות אינה זהה לבקשת ביטול רגילה. אם חלפה תקופת הביטול אך קיימת טענת פגם, אחריות או אי־התאמה, פנו אלינו ונבדוק את המקרה לפי תנאי האחריות וזכויותיכם לפי הדין.</p>
  </Section>

  <Section title="15. איך מתחילים החזרה או ביטול">
   <div className="mlc-return-steps">
    <div><b>1</b><span><strong>פונים אלינו</strong>עם מספר ההזמנה ומה מבקשים לבצע.</span></div>
    <div><b>2</b><span><strong>מקבלים הנחיות</strong>נעדכן אם נדרש משלוח חזרה, איסוף או פעולה אחרת.</span></div>
    <div><b>3</b><span><strong>בדיקה וטיפול</strong>לאחר קבלת המוצר/המידע נבצע את הטיפול המתאים.</span></div>
    <div><b>4</b><span><strong>החלפה או החזר</strong>בהתאם לבקשה, למלאי ולזכאות לפי דין.</span></div>
   </div>
   <p><button className="mlc-inline-action" onClick={()=>onNavigate('cancel')}>להודעת ביטול עסקה ←</button></p>
  </Section>

  <Section title="16. יצירת קשר">
   <p>שירות לקוחות MIELLEY: <a href={`mailto:${email}`}>{email}</a> · <a href={`tel:${phone}`}>{phone}</a>.</p>
   <p>מפעיל האתר: מיכה לסרי, מס׳ עוסק/זיהוי 031755705, רפאלי שרגא 9, פתח תקווה.</p>
   <p>הוראות מדיניות זו כפופות לדין. במקרה של סתירה בין המדיניות לבין הוראה קוגנטית בחוק — הוראת החוק גוברת.</p>
   <p className="mlc-updated">עדכון אחרון: 26.08.2026</p>
  </Section>
 </>;
}


function Terms({email,phone,onNavigate}:{email:string;phone:string;onNavigate:(d:LegalDoc)=>void}){
 return <>
  <div className="mlc-doc-intro">
   <span>MIELLEY · LEGAL</span>
   <h2>תקנון ותנאי שימוש ורכישה</h2>
   <p>התקנון מסדיר את השימוש באתר ואת רכישת תכשיטי MIELLEY. בכל מקום שבו הוראת דין קוגנטית מעניקה לצרכן זכות מיטיבה יותר — הדין גובר.</p>
  </div>
  <BusinessBox email={email} phone={phone}/>
  <Section title="1. כללי, קבלת התנאים וזהות העוסק">
   <p>האתר MIELLEY (להלן: “האתר”) הוא אתר מסחר אלקטרוני למכירת תכשיטים, ובכלל זה תכשיטי מוסונייט וכסף 925. גלישה באתר, פתיחת חשבון, מסירת פרטים או ביצוע הזמנה מהווים אישור לכך שקראתם את התנאים הרלוונטיים והסכמתם להם, בכפוף לכל דין.</p>
   <p>מפעיל האתר הוא {BUSINESS_NAME}, מס׳ עוסק/זיהוי {BUSINESS_ID}, כתובת {BUSINESS_ADDRESS}. שאלות ניתן להפנות ל־{email} או לטלפון {phone}.</p>
   <p>הכותרות נועדו לנוחות בלבד. לשון יחיד כוללת רבים ולהפך; לשון זכר/נקבה מתייחסת לכל המגדרים.</p>
  </Section>
  <Section title="2. כשירות לביצוע רכישה וחשבון משתמש">
   <p>ביצוע עסקה מיועד למי שמוסמך משפטית להתקשר בעסקה. משתמש שטרם מלאו לו 18 מתבקש לבצע רכישה באישור הורה או אפוטרופוס. האתר רשאי לדרוש פרטים סבירים לצורך אימות הזמנה, מניעת הונאה ומתן שירות.</p>
   <p>באחריות המשתמש למסור פרטים נכונים, מלאים ועדכניים ולשמור בסוד פרטי התחברות. אין להשתמש בחשבון של אדם אחר ללא הרשאה.</p>
  </Section>
  <Section title="3. המוצרים — מוסונייט, כסף 925 ותיאור התכשיט">
   <p>מוסונייט הוא אבן חן נפרדת מיהלום. ככל שמוצר כולל מוסונייט, הדבר יצוין בתיאורו. “כסף 925” מתייחס לסגסוגת סטרלינג שבה 92.5% כסף, בכפוף למפרט המוצר. ייתכנו ציפויים כגון רודיום או גוון זהב, אם צוינו בדף המוצר.</p>
   <p>האתר עושה מאמץ להציג תמונות, מידות, גוונים, משקל, קראט/משקל אבן, מידות אבנים ומאפיינים באופן מדויק. עם זאת, תצוגת צבע במסך, הגדלה בצילום, תאורה, עבודת יד והבדלים זעירים בין אבנים ותכשיטים עשויים לגרום לסטייה חזותית סבירה שאינה מהווה בהכרח אי־התאמה.</p>
   <p>במקרה של סתירה בין תמונה כללית לבין מפרט כתוב ומפורש של מוצר מסוים, יש לפנות אלינו לפני הזמנה. אין באמור כדי לגרוע מאחריות בשל הטעיה, פגם או אי־התאמה לפי דין.</p>
  </Section>
  <Section title="4. מחירים, מע״מ, מבצעים וקופונים">
   <p>אלא אם צוין אחרת במפורש, המחירים המוצגים לצרכן בישראל הם בשקלים חדשים וכוללים מע״מ כדין. עלות משלוח או שירות נוסף, אם קיימת, תוצג לפני השלמת ההזמנה.</p>
   <p>מחיר “רגיל”, “לפני הנחה” או מחיר מחוק יוצג בהתאם למדיניות האתר ולדין. מבצעים, קופונים והטבות כפופים לתנאיהם, לתוקף ולמלאי. לא ניתן לכפל הטבות אלא אם נאמר אחרת.</p>
   <p>במקרה של תקלה טכנית או טעות הקלדה מובהקת במחיר/מפרט, האתר יפעל לתיקון הטעות ויצור קשר עם הלקוח ככל שנדרש, והכול בכפוף לחוק הגנת הצרכן ולכל דין.</p>
  </Section>
  <Section title="5. ביצוע הזמנה, אישור, מלאי וסליקה">
   <p>הצגת מוצר באתר אינה מבטיחה מלאי בכל רגע. לאחר מסירת פרטי הזמנה ייתכן שתבוצע בדיקת זמינות, אימות פרטים ואישור תשלום. עסקה תיחשב מאושרת לאחר שהאתר אישר אותה בהתאם לתהליך הרכישה.</p>
   <p>אם מוצר אינו זמין, אם לא ניתן לאשר תשלום או אם קיימת מניעה מהותית אחרת, ניצור קשר ונפעל לביטול/השבה לפי העניין והדין. האתר רשאי לנקוט אמצעי מניעת הונאה סבירים.</p>
   <p>ככל שמופעל ספק סליקה חיצוני, פרטי כרטיס מלאים מעובדים אצל ספק הסליקה ולא אמורים להישמר במערכות MIELLEY, אלא אם נאמר אחרת במפורש ובכפוף לדין.</p>
  </Section>
  <Section title="6. מידות, התאמות אישיות והזמנה מיוחדת">
   <p>על הלקוח לבדוק את המידה לפני הזמנה ולהיעזר במדריך המידות או בשירות הלקוחות. בחירת מידה מתוך אפשרויות סטנדרטיות אינה מוגדרת אוטומטית כהזמנה מיוחדת.</p>
   <p>מוצר שיוצר, נחרט, הותאם או שונה במיוחד לפי מידות או דרישות אישיות של הלקוח עשוי להיות כפוף להסדרי ביטול שונים. החרגה מזכות ביטול תחול רק ככל שמתקיימים התנאים שנקבעו בדין. ככל שהדין מאפשר ביטול מוצר בהזמנה אישית לפני תחילת הייצור או בתוך פרק זמן מסוים — נפעל בהתאם.</p>
  </Section>
  <Section title="7. משלוחים, מסירה ועיכובים">
   <p>אפשרויות ועלויות המשלוח יוצגו באתר או בתהליך ההזמנה. מועדי אספקה הם בהתאם למה שנמסר בעסקה ובכפוף לדין. ייתכנו עיכובים חריגים עקב חברת שילוח, מצב ביטחוני, מזג אוויר, עומסים, חגים או אירועים שאינם בשליטת האתר; במקרה כזה נעדכן ככל שניתן ונפעל בהתאם לזכויות הצרכן לפי דין.</p>
   <p>באחריות הלקוח למסור כתובת ופרטי קשר מדויקים. מסירה לכתובת/נקודת מסירה בהתאם לפרטים שמסר הלקוח תיחשב מסירה, בכפוף לכל דין ולתיעוד חברת השילוח.</p>
  </Section>
  <Section id="cancellation" title="8. ביטול עסקה, החזרות והחלפות">
   <p>זכויות ביטול והחזרה יחולו בהתאם לחוק הגנת הצרכן, התשמ״א–1981, לתקנות מכוחו ולכל דין מחייב. בעסקת מכר מרחוק של מוצר קיימת בדרך כלל זכות ביטול בתוך 14 ימים מהמועד הקובע לפי החוק; במקרים מסוימים קיימת תקופת ביטול ארוכה יותר לאדם עם מוגבלות, אזרח ותיק או עולה חדש, בהתקיים התנאים שבדין.</p>
   <p>בביטול שאינו עקב פגם, אי־התאמה או אי־אספקה במועד, ניתן לגבות דמי ביטול עד השיעור המותר בדין — בדרך כלל 5% ממחיר העסקה או 100 ₪, לפי הנמוך. אם הביטול נובע מפגם, אי־התאמה, אי־אספקה במועד או הפרה אחרת המזכה לפי הדין, לא ייגבו דמי ביטול ככל שהחוק אוסר זאת.</p>
   <p>כאשר האחריות להחזרת המוצר מוטלת על הלקוח לפי הדין, ההחזרה תיעשה בתיאום ובאופן שמגן על התכשיט. במקרה של מוצר פגום או אי־התאמה נפעל בהתאם לחובות האיסוף/ההשבה החלות לפי הדין.</p>
   <p>מוצר שהוכן במיוחד לפי מידות או דרישות מיוחדות עשוי להיות מוחרג או כפוף למגבלות ביטול, רק ככל שהדין מתיר. אין בתקנון כדי לשלול זכות שלא ניתן להתנות עליה.</p>
   <p><button className="mlc-inline-action" onClick={()=>onNavigate('cancel')}>לפתיחת הודעת ביטול עסקה ←</button></p>
  </Section>
  <Section title="9. החזר כספי">
   <p>כאשר קיימת זכות להשבה, ההחזר יבוצע במועדים ובאופן הקבועים בדין ובדרך התשלום האפשרית הרלוונטית. ייתכן שהופעת הזיכוי בפועל אצל חברת האשראי/הבנק תושפע מזמני העיבוד של הגורם הפיננסי.</p>
  </Section>
  <Section title="10. אחריות, טיפול ובלאי טבעי">
   <p>ככל שמוצגת באתר אחריות לשנה, היא נועדה לכסות פגם ייצור בהתאם לתנאיה ואינה גורעת מזכויות לפי דין. בלאי טבעי, שריטות, מכות, עיקום, אובדן אבנים עקב פגיעה, שימוש בחומרים כימיים, שחיקה טבעית של ציפוי, תיקון בידי צד שלישי או שימוש שאינו סביר עשויים שלא להיחשב פגם ייצור.</p>
   <p>כסף 925 וציפויים עשויים להגיב לסביבה, לחות, זיעה, כלור, חומרי ניקוי, בושם ותכשירים קוסמטיים. מומלץ להסיר תכשיטים לפני ים/בריכה/ספורט ולאחסן במקום יבש. כל מקרה ייבחן לגופו ובכפוף לדין.</p>
  </Section>
  <Section title="11. שירותי צד שלישי וקישורים">
   <p>האתר עשוי להסתייע בספקי אחסון, אימות משתמשים, משלוחים, תשלומים, דיוור ושירותים טכנולוגיים. פעילות ספקים חיצוניים עשויה להיות כפופה גם לתנאיהם ולמדיניות הפרטיות שלהם. אין בכך כדי לגרוע מחובות MIELLEY לפי דין ביחס לשירות שהיא מספקת.</p>
  </Section>
  <Section title="12. קניין רוחני">
   <p>המותג MIELLEY, עיצוב האתר, טקסטים מקוריים, גרפיקה, לוגו, צילומים ותכנים שבבעלות האתר מוגנים לפי דיני הקניין הרוחני. אין להעתיק, לפרסם, להעמיד לרשות הציבור, לבצע שימוש מסחרי או ליצור יצירה נגזרת ללא הרשאה, למעט שימוש המותר במפורש לפי דין.</p>
  </Section>
  <Section title="13. שימוש אסור ואבטחת האתר">
   <p>אין לנסות לעקוף מנגנוני אבטחה, לבצע סריקות אוטומטיות מכבידות, לשבש את האתר, להחדיר קוד זדוני, להתחזות לאחר, לבצע הונאה או להשתמש באתר באופן בלתי חוקי. האתר רשאי לחסום פעילות חריגה ולשמור תיעוד לצורכי אבטחה, מניעת הונאה והגנה על זכויות, בכפוף למדיניות הפרטיות ולדין.</p>
  </Section>
  <Section title="14. אחריות והגבלת אחריות">
   <p>האתר פועל לספק שירות תקין, אך מערכות אינטרנט אינן חסינות מתקלות, השבתות או אירועי סייבר. לא תוטל על MIELLEY אחריות מעבר למותר בדין, ואין בסעיף זה כדי לפטור מאחריות שלא ניתן לפטור ממנה לפי חוק, לרבות בגין הטעיה, פגם, אי־התאמה או הפרת חובה צרכנית מחייבת.</p>
  </Section>
  <Section title="15. פרטיות ונגישות">
   <p>השימוש במידע אישי כפוף ל<button className="mlc-text-btn" onClick={()=>onNavigate('privacy')}>מדיניות הפרטיות</button>. מידע על התאמות ושירות נגיש מופיע ב<button className="mlc-text-btn" onClick={()=>onNavigate('accessibility')}>הצהרת הנגישות</button>.</p>
  </Section>
  <Section title="16. שינוי התקנון, הדין החל ויישוב מחלוקות">
   <p>האתר רשאי לעדכן את התקנון מעת לעת. גרסה מעודכנת תחול ממועד פרסומה ואילך, אלא אם הדין דורש אחרת. על השימוש באתר יחול דין מדינת ישראל. סמכות השיפוט תהיה לבתי המשפט המוסמכים בהתאם לכללי הסמכות המקומית והעניינית החלים לפי דין, ואין בתנאי זה כדי לשלול זכות צרכנית קוגנטית.</p>
  </Section>
  <Section title="17. יצירת קשר">
   <p>לשאלות בנוגע להזמנה, החזרה, אחריות או התקנון: <a href={`mailto:${email}`}>{email}</a> · <a href={`tel:${phone}`}>{phone}</a>.</p>
   <p className="mlc-updated">עדכון אחרון: {UPDATED}</p>
  </Section>
 </>;
}

function Privacy({email,phone,onNavigate}:{email:string;phone:string;onNavigate:(d:LegalDoc)=>void}){
 return <>
  <div className="mlc-doc-intro">
   <span>MIELLEY · PRIVACY</span>
   <h2>מדיניות פרטיות</h2>
   <p>מדיניות זו מסבירה איזה מידע עשוי להיאסף באתר, מדוע הוא נדרש, עם מי הוא עשוי להיות משותף ומהן זכויותיכם.</p>
  </div>
  <BusinessBox email={email} phone={phone}/>
  <Section title="1. בעל השליטה במידע">
   <p>בעל השליטה במידע הנאסף לצורך הפעלת MIELLEY הוא {BUSINESS_NAME}, מס׳ עוסק/זיהוי {BUSINESS_ID}, כתובת {BUSINESS_ADDRESS}. לפניות פרטיות: <a href={`mailto:${email}`}>{email}</a> או <a href={`tel:${phone}`}>{phone}</a>.</p>
  </Section>
  <Section title="2. האם חובה למסור מידע ומה קורה אם לא מוסרים">
   <p>ככלל, מסירת מידע באתר תלויה ברצונכם ובהסכמתכם, אלא אם קיימת חובה בדין. עם זאת, ללא פרטים מסוימים לא נוכל לבצע פעולה שביקשתם — לדוגמה, ללא שם ופרטי קשר לא ניתן לטפל בהזמנה או פנייה; ללא כתובת לא ניתן לשלוח מוצר; ללא פרטי אימות לא ניתן לפתוח או לאבטח חשבון משתמש.</p>
  </Section>
  <Section title="3. סוגי מידע שעשויים להיאסף">
   <ul>
    <li><b>פרטי זיהוי וקשר:</b> שם, טלפון, דוא״ל, כתובת למשלוח ופרטים שתמסרו בטפסים.</li>
    <li><b>מידע על הזמנות:</b> מוצרים, מידות, סכומים, הנחות, סטטוס הזמנה, החזרות, שירות ואחריות.</li>
    <li><b>חשבון משתמש:</b> מזהי חשבון, כתובת דוא״ל, כתובות שמורות, העדפות ונתונים הקשורים לחשבון.</li>
    <li><b>פעילות באתר:</b> עגלת קניות, מועדפים, השוואות, העדפות נגישות ושפה, ונתונים טכניים הדרושים להפעלת השירות.</li>
    <li><b>מידע טכני ואבטחה:</b> כתובת IP, סוג דפדפן/מכשיר, אירועי אבטחה, לוגים ונתוני שגיאה, ככל שנאספים בפועל.</li>
    <li><b>תקשורת איתנו:</b> תוכן פניות, WhatsApp/דוא״ל ושיחות שירות ככל שנשמרות.</li>
   </ul>
  </Section>
  <Section title="4. מטרות השימוש במידע">
   <p>המידע עשוי לשמש להפעלת האתר, ניהול חשבון, ביצוע ואספקת הזמנות, שירות לקוחות, אחריות והחזרות, התאמת חוויית משתמש, אבטחת מידע ומניעת הונאה, ניהול חשבונאי ומשפטי, שיפור האתר, טיפול בתקלות, עמידה בדרישות דין והגנה על זכויות משפטיות.</p>
   <p>שיווק ישיר או דיוור פרסומי יישלחו רק בהתאם לדין ולהסכמה הנדרשת. ניתן לבקש הסרה בכל עת בדרך המפורטת בהודעה או בפנייה אלינו.</p>
  </Section>
  <Section title="5. Cookies, localStorage וטכנולוגיות דומות">
   <p>האתר משתמש או עשוי להשתמש בקובצי Cookies, אחסון מקומי וטכנולוגיות דומות לצורך התחברות, אבטחה, שמירת עגלה, מועדפים, העדפות נגישות ושפה ותפקוד שוטף. ככל שיופעלו בעתיד כלי אנליטיקה, מדידה או פרסום שאינם חיוניים, השימוש בהם ייעשה בהתאם לדרישות הדין ולהסכמות הנדרשות.</p>
   <p>ניתן למחוק או לחסום Cookies דרך הגדרות הדפדפן, אך חסימת טכנולוגיות חיוניות עלולה לפגוע בפעילות האתר.</p>
  </Section>
  <Section title="6. תשלום">
   <p>ככל שמופעל שירות סליקה, מידע הדרוש לתשלום יועבר לספק הסליקה. MIELLEY אינה אמורה לשמור מספר כרטיס אשראי מלא במערכות האתר, אלא אם הדבר נאמר במפורש ומבוצע בהתאם לדין ולתקני אבטחה מתאימים.</p>
  </Section>
  <Section title="7. מסירת מידע לצדדים שלישיים">
   <p>מידע עשוי להימסר, במידה הדרושה ולמטרה הרלוונטית, לספקי ענן ואחסון, שירותי אימות משתמשים, סליקה, חברות שילוח, שירותי דוא״ל/הודעות, תמיכה טכנית, יועצים מקצועיים ורשויות מוסמכות כאשר קיימת חובה או סמכות בדין.</p>
   <p>ספק חיצוני המעבד מידע עבורנו אמור לקבל רק את המידע הנדרש לתפקידו ובהתאם להסדרים החלים. חלק מהספקים עשויים לעבד או לאחסן מידע מחוץ לישראל; העברה כאמור תיעשה בהתאם לדין החל.</p>
  </Section>
  <Section title="8. אבטחת מידע">
   <p>אנו נוקטים אמצעים ארגוניים וטכנולוגיים סבירים המתאימים לאופי הפעילות, במטרה לצמצם גישה בלתי מורשית, אובדן, שימוש לרעה או חשיפה. אין מערכת מקוונת החסינה לחלוטין. במקרה של אירוע אבטחה נפעל בהתאם לחובות החלות לפי דין.</p>
  </Section>
  <Section title="9. שמירת מידע">
   <p>המידע יישמר כל עוד הוא נדרש למטרות שלשמן נאסף, לצורך מתן שירות, ניהול הזמנות ואחריות, התגוננות משפטית, אבטחה ועמידה בחובות חשבונאיות/מס או חובות אחרות לפי דין. לאחר מכן המידע יימחק, יעבור אנונימיזציה או יישמר רק אם קיימת עילה חוקית להמשך שמירתו.</p>
  </Section>
  <Section title="10. זכויות עיון ותיקון">
   <p>בהתאם לחוק הגנת הפרטיות ובכפוף לתנאיו, אדם זכאי לעיין במידע אישי עליו המוחזק במאגר, וכן לבקש לתקן מידע שאינו נכון, שלם, ברור או מעודכן. כאשר הדין מקנה זכות מחיקה או התנגדות לשימוש מסוים, ניתן לפנות אלינו למימושה.</p>
   <p>בקשה יש לשלוח ל־<a href={`mailto:${email}`}>{email}</a>. לצורך הגנה על הפרטיות נוכל לבקש פרטי זיהוי סבירים לפני מסירת מידע או שינויו.</p>
  </Section>
  <Section title="11. קטינים">
   <p>האתר אינו מיועד לאיסוף מכוון של מידע מילדים ללא הרשאה מתאימה. אם נודע להורה/אפוטרופוס כי קטין מסר מידע אישי באופן שאינו מורשה, ניתן לפנות אלינו לבחינת מחיקתו בכפוף לדין.</p>
  </Section>
  <Section title="12. קישורים ושירותים חיצוניים">
   <p>קישורים לשירותים חיצוניים, לרבות WhatsApp או שירותי תשלום ומשלוח, עשויים להיות כפופים למדיניות הפרטיות של אותם גורמים. מומלץ לעיין במדיניות שלהם.</p>
  </Section>
  <Section title="13. עדכונים למדיניות">
   <p>המדיניות עשויה להתעדכן עקב שינוי טכנולוגי, עסקי או משפטי. הגרסה המעודכנת תפורסם באתר עם מועד העדכון.</p>
   <p>למידע על תנאי הרכישה ניתן לעבור ל<button className="mlc-text-btn" onClick={()=>onNavigate('terms')}>תקנון האתר</button>.</p>
   <p className="mlc-updated">עדכון אחרון: {UPDATED}</p>
  </Section>
 </>;
}

function Accessibility({email,phone}:{email:string;phone:string}){
 return <>
  <div className="mlc-doc-intro">
   <span>MIELLEY · ACCESSIBILITY</span>
   <h2>הצהרת נגישות</h2>
   <p>MIELLEY רואה חשיבות במתן אפשרות שוויונית ונוחה ככל האפשר לשימוש באתר לאנשים עם מוגבלות.</p>
  </div>
  <BusinessBox email={email} phone={phone}/>
  <Section title="1. מחויבות לנגישות">
   <p>האתר פועל לשיפור נגישותו בהתאם לעקרונות חוק שוויון זכויות לאנשים עם מוגבלות, תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), ולתקן הישראלי ת״י 5568, ככל שהוראות אלה חלות על האתר.</p>
   <p>מטרתנו היא להגיע לרמת נגישות גבוהה וליישם עקרונות ברמת AA ככל הניתן. מאחר שהאתר מתעדכן באופן שוטף, ייתכן שרכיבים או תכנים מסוימים טרם הונגשו באופן מלא. אין בהצהרה זו מצג שבוצעה בדיקת הסמכה משפטית או טכנולוגית מלאה על ידי מורשה נגישות, אלא אם יפורסם אחרת.</p>
  </Section>
  <Section title="2. כלי הנגישות הקיים באתר">
   <p>באתר משולב תפריט נגישות המאפשר, בין היתר ובהתאם לגרסה הפעילה: שינוי גודל טקסט, גובה שורה ומשקל גופן; התאמת ריווח אותיות; גופן קריא; יישור טקסט; מצבי ניגודיות; מונוכרום; הדגשת קישורים; עצירת אנימציות/וידאו; הסתרת תמונות; מסכת קריאה וקו קריאה; הדגשת תוכן; וקישור דילוג לתוכן.</p>
   <p>העדפות מסוימות עשויות להישמר בדפדפן כדי לשמור על בחירת המשתמש.</p>
  </Section>
  <Section title="3. שימוש במקלדת וטכנולוגיות מסייעות">
   <p>אנו פועלים לכך שרכיבים מרכזיים יהיו ניתנים להפעלה באמצעות מקלדת, עם סדר מיקוד הגיוני, תוויות מתאימות ושימוש במבנה סמנטי. ניתן להשתמש במקש Tab למעבר בין רכיבים, Shift+Tab לחזרה ו־Enter/Space להפעלה ברכיבים תומכים.</p>
   <p>אם נתקלתם ברכיב שאינו ניתן להפעלה באמצעות מקלדת או קורא מסך, נשמח לקבל פרטים מדויקים כדי לתקן אותו.</p>
  </Section>
  <Section title="4. תמונות, צבע, טקסט ותנועה">
   <p>אנו פועלים להוסיף טקסט חלופי לתמונות משמעותיות, לשמור על ניגודיות קריאה מתאימה, לאפשר הגדלת טקסט ולצמצם תלות בצבע בלבד. תכני וידאו/אנימציה מתעדכנים מעת לעת, ובמקרה של קושי ניתן להשתמש בכלי עצירת האנימציות או לפנות לקבלת חלופה נגישה.</p>
  </Section>
  <Section title="5. מסמכים ותכנים של צד שלישי">
   <p>ייתכן שבאתר משולבים רכיבים או שירותים של צדדים שלישיים שעליהם אין לנו שליטה מלאה. אנו משתדלים לבחור פתרונות נגישים ולספק חלופה סבירה כאשר ניתן. אם מסמך או תוכן מסוים אינו נגיש, ניתן לפנות אלינו לקבלת סיוע או חלופה בהתאם לדין.</p>
  </Section>
  <Section title="6. הסדרי נגישות פיזיים">
   <p>MIELLEY פועלת בעיקר כשירות מקוון. הכתובת הרשומה אינה מוצגת כחנות הפתוחה לקבלת קהל ללא תיאום. אם יתואם שירות פיזי או איסוף, ניתן לפנות מראש לקבלת מידע נקודתי על הסדרי הנגישות הרלוונטיים למקום ולשירות.</p>
  </Section>
  <Section title="7. פנייה בנושא נגישות">
   <p>אם מצאתם בעיית נגישות, פרטו ככל האפשר את העמוד, הפעולה שניסיתם לבצע, הדפדפן/המכשיר והטכנולוגיה המסייעת שבה השתמשתם. איש קשר לפניות נגישות: {BUSINESS_NAME}.</p>
   <p>דוא״ל: <a href={`mailto:${email}`}>{email}</a> · טלפון: <a href={`tel:${phone}`}>{phone}</a>.</p>
   <p>אנו נעשה מאמץ סביר לבדוק את הפנייה, להשיב ולספק פתרון או חלופה מתאימה ככל שניתן ובהתאם לדין.</p>
  </Section>
  <Section title="8. עדכון ההצהרה">
   <p>הצהרת הנגישות תיבחן ותעודכן מעת לעת בהתאם לשינויים באתר, בשירות ובהוראות הדין.</p>
   <p className="mlc-updated">עדכון אחרון: {UPDATED}</p>
  </Section>
 </>;
}

function Cancel({email,phone}:{email:string;phone:string}){
 const [name,setName]=useState('');
 const [id,setId]=useState('');
 const [order,setOrder]=useState('');
 const [contact,setContact]=useState('');
 const [note,setNote]=useState('');
 const [copied,setCopied]=useState(false);

 const body=()=>{
  return [
   'שלום MIELLEY,',
   '',
   'אבקש למסור הודעת ביטול עסקה בהתאם לדין.',
   `שם מלא: ${name}`,
   `מספר זהות: ${id}`,
   `מספר הזמנה: ${order}`,
   `טלפון/דוא״ל לחזרה: ${contact}`,
   note?`הערה (אופציונלית): ${note}`:'',
   '',
   'אבקש אישור קבלת הודעת הביטול והנחיות להמשך.',
  ].filter(Boolean).join('\n');
 };

 const send=()=>{
   const subject=`בקשת ביטול עסקה${order?` – הזמנה ${order}`:''}`;
   window.location.href=`mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body())}`;
 };
 const copy=async()=>{
   try{await navigator.clipboard.writeText(body());setCopied(true);setTimeout(()=>setCopied(false),1800)}catch{}
 };

 return <>
  <div className="mlc-doc-intro">
   <span>MIELLEY · CANCELLATION</span>
   <h2>הודעת ביטול עסקה</h2>
   <p>העמוד מאפשר להכין הודעת ביטול מסודרת. מסירת סיבת הביטול אינה חובה. הזכאות לביטול, המועדים וההשבה נקבעים לפי הדין.</p>
  </div>
  <BusinessBox email={email} phone={phone}/>
  <Section title="איך ניתן למסור הודעת ביטול">
   <p>ניתן לפנות בדוא״ל ל־<a href={`mailto:${email}`}>{email}</a>, בטלפון <a href={`tel:${phone}`}>{phone}</a>, בדואר לכתובת {BUSINESS_ADDRESS}, ובכל דרך נוספת שהדין מחייב את העסק לאפשר.</p>
   <p>הטופס להלן אינו שולח מידע לשרת האתר; הוא מכין הודעת דוא״ל במכשיר שלכם. יש לוודא שהודעת הדוא״ל אכן נשלחה. ניתן גם להעתיק את הנוסח ולשלוח אותו ידנית.</p>
  </Section>
  <div className="mlc-cancel-form">
   <label>שם מלא<input value={name} onChange={e=>setName(e.target.value)} autoComplete="name"/></label>
   <label>מספר זהות<input value={id} onChange={e=>setId(e.target.value)} inputMode="numeric"/></label>
   <label>מספר הזמנה<input value={order} onChange={e=>setOrder(e.target.value)}/></label>
   <label>טלפון או דוא״ל לחזרה<input value={contact} onChange={e=>setContact(e.target.value)}/></label>
   <label className="full">הערה — לא חובה<textarea value={note} onChange={e=>setNote(e.target.value)} rows={3}/></label>
   <div className="mlc-cancel-actions">
    <button className="primary" onClick={send} disabled={!name||!id}>פתיחת הודעת ביטול בדוא״ל</button>
    <button onClick={()=>void copy()}>{copied?'הנוסח הועתק ✓':'העתקת נוסח הביטול'}</button>
   </div>
  </div>
  <Section title="לתשומת לב">
   <p>עצם שליחת הודעת ביטול אינה קובעת לבדה שקיימת זכות ביטול בכל מקרה; הזכאות תיבחן בהתאם לסוג המוצר, מועד העסקה, מצב המוצר, התאמה אישית והוראות החוק. אין בכך כדי לגרוע מזכות כלשהי המוקנית לצרכן לפי דין.</p>
   <p className="mlc-updated">עדכון אחרון: {UPDATED}</p>
  </Section>
 </>;
}

export function LegalCenter({open,onClose,onNavigate,email,phone}:Props){
 const closeRef=useRef<HTMLButtonElement>(null);

 useEffect(()=>{
   if(!open)return;
   const old=document.body.style.overflow;
   document.body.style.overflow='hidden';
   const key=(e:KeyboardEvent)=>{if(e.key==='Escape')onClose()};
   window.addEventListener('keydown',key);
   requestAnimationFrame(()=>closeRef.current?.focus());
   return ()=>{document.body.style.overflow=old;window.removeEventListener('keydown',key)};
 },[open,onClose]);

 if(!open)return null;
 const title=open==='shipping'?'משלוחים והחזרות':open==='terms'?'תקנון':open==='privacy'?'פרטיות':open==='accessibility'?'נגישות':'ביטול עסקה';

 return <div className="mlc-overlay" role="presentation" onMouseDown={e=>{if(e.target===e.currentTarget)onClose()}}>
  <div className="mlc-dialog" role="dialog" aria-modal="true" aria-label={title} dir="rtl">
   <header className="mlc-top">
    <div className="mlc-wordmark"><b>MIELLEY</b><small>LEGAL & TRUST CENTER</small></div>
    <nav aria-label="מסמכים משפטיים">
     <button className={open==='shipping'?'active':''} onClick={()=>onNavigate('shipping')}>משלוחים והחזרות</button>
     <button className={open==='terms'?'active':''} onClick={()=>onNavigate('terms')}>תקנון</button>
     <button className={open==='privacy'?'active':''} onClick={()=>onNavigate('privacy')}>פרטיות</button>
     <button className={open==='accessibility'?'active':''} onClick={()=>onNavigate('accessibility')}>נגישות</button>
     <button className={open==='cancel'?'active':''} onClick={()=>onNavigate('cancel')}>ביטול עסקה</button>
    </nav>
    <button ref={closeRef} className="mlc-close" onClick={onClose} aria-label="סגירת החלון">×</button>
   </header>
   <div className="mlc-body" tabIndex={0}>
    <main className="mlc-content">
     {open==='shipping'&&<Shipping email={email} phone={phone} onNavigate={onNavigate}/>}
     {open==='terms'&&<Terms email={email} phone={phone} onNavigate={onNavigate}/>}
     {open==='privacy'&&<Privacy email={email} phone={phone} onNavigate={onNavigate}/>}
     {open==='accessibility'&&<Accessibility email={email} phone={phone}/>}
     {open==='cancel'&&<Cancel email={email} phone={phone}/>}
    </main>
   </div>
   <footer className="mlc-bottom">
    <span>MIELLEY · {BUSINESS_NAME} · {BUSINESS_ID}</span>
    <span>{BUSINESS_ADDRESS} · {email}</span>
   </footer>
  </div>
 </div>;
}
